import { useTranslation } from '@zurich/common/hooks';
import { Button, Stack, Typography } from '@zurich/ui/atoms';
import { styled } from '@zurich/ui/legacy/utils';

type DocumentDamageDataEntryHeaderProps = {
  resetImageBlob: (id: string | undefined) => void;
  handleShowDamageContent: () => void;
  damageId: string;
};

export function DocumentDamageDataEntryHeader({
  handleShowDamageContent,
  resetImageBlob,
  damageId,
}: DocumentDamageDataEntryHeaderProps) {
  const { t } = useTranslation();

  const handleBackButton = () => {
    resetImageBlob(damageId);
    handleShowDamageContent();
  };

  return (
    <StackStyled columnGap={3}>
      <DivStyled>
        <Button onClick={handleBackButton} icon="arrow-left-1" variant="text" />
      </DivStyled>
      <Typography variant="body1 semibold" color="darkBlue">
        {t('vsga:damagePhoto.subtitleDocumentation')}
      </Typography>
      <DivStyled />
    </StackStyled>
  );
}

const DivStyled = styled('div')(() => ({
  flex: '1 1',
}));

const StackStyled = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  minWidth: '300px',
  position: 'sticky',
  top: '0px',
  height: theme.spacing(4),
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  zIndex: '100',
}));
